import React from "react";
import { Col, Row, Form, Modal, Select, Radio, Spin, InputNumber } from "antd";
import { URL_SALE, URL_TANK } from "../../constants/urls";
import { GET, POST } from "../../frameworks/HttpClient";
import _ from "lodash";
import ErrorMessages from "../../common/ErrorMessages";
import { TANK_STATUS } from "../../constants/string";

const LOT_SELF_ORDER = "self_order"
const LOT_ALL_ORDER = "all_order"
const LOT_ALL = "all"

export default function LoadModal(props) {
  const { open, onClose, target, onUpdate, saleOrder } = props;
  const [errorMessages, setErrorMessages] = React.useState(null)
  const [debouncedLot, setDebouncedLot] = React.useState(null);
  const [fetching, setFetching] = React.useState(null);
  const [lotOptions, setLotOptions] = React.useState(null);

  const [form] = Form.useForm();
  const selfOrder = Form.useWatch("self_order", form);

  const debounceLot = React.useCallback(_.debounce((_searchVal) => { setDebouncedLot(_searchVal) }, 800), []);

  const fetchLotTank = async () => {
    setFetching(true);
    try {
      const params = { lot_no : debouncedLot, state : TANK_STATUS.SELLING }
      if(selfOrder == LOT_SELF_ORDER) {
        params['sale_order'] = saleOrder.id
      }
      else if(selfOrder == LOT_ALL_ORDER) {
        params['product'] = saleOrder.product
      }
      
      const response = await GET(`${URL_TANK.TANK_TRANSACTION}`, params)
      setLotOptions(response.data.results.map((item) => {
        return {
          ...item,
          label: `${item.lot_no} [${item.tank_name}] : ${item.current_weight}`,
          value: item.id
        }
      }))
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setFetching(false);
    }
  }

  const handleOK = async () => {
    setErrorMessages(null)
    try {
      const data = await form.validateFields();
      data['delivery_order'] = target.id
      await POST(URL_SALE.LOAD_TANK_TRANSACTION, data);
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  };

  React.useEffect(() => {
    if(open)
      fetchLotTank();
  },[debouncedLot])

  React.useEffect(() => {
    if(selfOrder != null){
      fetchLotTank();
    }
  },[selfOrder])

  React.useEffect(() => {
    setErrorMessages(null)
    if(open)
      form.setFieldValue('self_order', LOT_SELF_ORDER)
  },[open])

  return(
    <Modal
      open={open}
      onCancel={() => {
        form.resetFields()
        onClose()
      }}
      cancelText={"ยกเลิก"}
      okText={"โหลด"}
      title={"โหลดน้ำยางข้น"}
      width={700}
      onOk={handleOK}
      centered
      destroyOnClose
    >
    <ErrorMessages message={errorMessages}/>
    <Form
      form={form}
      style={{ margin: "auto" }}
      layout="horizontal"
    >
      <Row gutter={10}>
        <Col>
          <Form.Item
            label="การเลือกล็อต : "
            name="self_order"
            rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
          >
            <Radio.Group 
              onChange={async(e) => {
                form.setFieldValue('tank_transaction', null)
              }}
            >
              <Radio value={LOT_SELF_ORDER}>ล็อตที่แจ้งผลิต</Radio>
              <Radio value={LOT_ALL_ORDER}>ล็อตตามชนิดสินค้า</Radio>
              <Radio value={LOT_ALL}>ล็อตทั้งหมด</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col span={14}>
          <Form.Item
            label="ล็อตน้ำยางข้น"
            name="tank_transaction"
            layout="vertical"
            rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
          >
          <Select 
            initialvalues={"-"}
            autoComplete="off" 
            showSearch
            filterOption={false}
            notFoundContent={fetching ? <Spin size="small" /> : "-"}
            onSearch={debounceLot}
            options={lotOptions}
            allowClear={"-"}/>
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item
            label="ปริมาณโหลด (Kg)"
            name="weight"
            layout="vertical"
            rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
          >
            <InputNumber placeholder="ปริมาณโหลด (Kg)" style={{ width : '100%'}}/>
          </Form.Item>
        </Col>
      </Row>
    </Form>

  </Modal>)
}